/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("DimensionQueryOperator");
    }

    getFixupPrototypeFunction() { return DimensionQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<DimensionQueryOperator>): DimensionQueryOperator {
        let obj = Object.assign(new DimensionQueryOperator(), model);
        DimensionQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionQueryOperator>): DimensionQueryOperator {
        if (!model) return null;
        return DimensionQueryOperator.newInstance(<DimensionQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionQueryOperator) {
        if (!obj) return;

        models.DimensionQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DimensionQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Dimension ID
     */
    dimension_id: string;

    /**
     * Attribute to filter
     */
    attribute: string;

    /**
     * Values for the given attribute
     */
    values: Array<string>;

    /**
     * Resolved group ids based on the attribute/values
     */
    grouping_rule_ids: Array<string>;

    /**
     * Combined filters of the resolved group ids
     */
    filters: models.QueryOperator;

}
